import { render, staticRenderFns } from "./technical-specifications-dashboard.vue?vue&type=template&id=325b5e80&scoped=true"
import script from "./technical-specifications-dashboard.vue?vue&type=script&lang=js"
export * from "./technical-specifications-dashboard.vue?vue&type=script&lang=js"
import style0 from "./technical-specifications-dashboard.vue?vue&type=style&index=0&id=325b5e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325b5e80",
  null
  
)

export default component.exports